import { render } from "./GfsCalendarGrid.vue?vue&type=template&id=08d6af0f&scoped=true"
import script from "./GfsCalendarGrid.vue?vue&type=script&lang=js"
export * from "./GfsCalendarGrid.vue?vue&type=script&lang=js"

import "./GfsCalendarGrid.vue?vue&type=style&index=0&id=08d6af0f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d6af0f"]])

export default __exports__